import axios from "axios";
import { buildQuery } from "utils/queryUtils";

export const findLicensingAgencies = (headers, params) => {
    let query = buildQuery(params, ["code", "name"]);
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/licensingAgency${query}`, {
        headers,
    });
};

export const findLicensingAgencyById = (headers, id) => {
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/licensingAgency/${id}`, {
        headers,
    });
};
